//MEAL PLAN CALCULATOR
    function MealPlanCalculator() {
    
        var $CurrentWeight = parseInt(document.getElementById("CurrentWeight").value);
        var $TargetWeight = parseInt(document.getElementById("TargetWeight").value);
        var $Height = parseInt(document.getElementById("Height").value);
        var $Age = parseInt(document.getElementById("Age").value);
        var $Gender = "Male";
        var $ActivityLevel = 1.375;
        var $BMR = 0;
        var $ProgramCal = 0;
        var $Interim = 0;


        //populate Gender variable
        if(document.getElementById('radioMale').checked) {
            $Gender = document.getElementById("radioMale").value;
        }else if(document.getElementById('radioFemale').checked) {
            $Gender = document.getElementById("radioFemale").value;
        }

        //populate Activity level variable
        //if(document.getElementById('radioNone').checked) {
        //    $ActivityLevel = document.getElementById("radioNone").value;}
        if(document.getElementById('radioLight').checked) {
            $ActivityLevel = document.getElementById("radioLight").value;
        }else if(document.getElementById('radioMedium').checked) {
            $ActivityLevel = document.getElementById("radioMedium").value;
        }else if(document.getElementById('radioVery').checked) {
            $ActivityLevel = document.getElementById("radioVery").value;
        }
        //else if(document.getElementById('radioExtreme').checked) {
        //    $ActivityLevel = document.getElementById("radioExtreme").value;}

   
    //Calc - Overall Weight Change
        var $WeightChange = Math.abs($CurrentWeight - $TargetWeight); 

    //Calc - BMR
        if ($Gender == "Male") {
            $BMR = (10*$CurrentWeight)+(6.25*$Height)-(5*$Age)+5;
        }
        else if ($Gender == "Female") {
            $BMR = (10*$CurrentWeight)+(6.25*$Height)-(5*$Age)+161;
        } 

    //Calculate TDEE
        var $TDEE = $BMR*$ActivityLevel;

    //Calc - BMI
        var $CurrentBMI = $CurrentWeight/(($Height/100)*($Height/100));
        var $TargetBMI = $TargetWeight/(($Height/100)*($Height/100));

        
    //Calculate Aussielent program

        if ($CurrentWeight > $TargetWeight) {
            $Interim = $TDEE - 600;
        }
        else if ($CurrentWeight < $TargetWeight) {
            $Interim = $TDEE + 600;
        }
        else {
             $Interim = $TDEE;
        }
        
        //Aussielent meal plan
        if ($Interim > 4000) {
            $ProgramCal = 4000;
        }
        else if ($Interim > 3500 && $Interim<=4000) {
            $ProgramCal = 3500;
        }
        else if ($Interim > 3000 && $Interim<=3500) {
            $ProgramCal = 3000;
        }
        else if ($Interim > 2500 && $Interim<=3000) {
            $ProgramCal = 2500;
        }
        else if ($Interim>2000 && $Interim<=2500) {
            $ProgramCal = 2000;
        }
        else if ($Interim>1750 && $Interim<=2000) {
            $ProgramCal = 1750;
        }
        else if ($Interim>1500 && $Interim<=1750){
            $ProgramCal=1500;
        }
        else if ($Interim>=1200 && $Interim<=1500){
            $ProgramCal=1200;
        }
        else {
            $ProgramCal = 2000;
        } 


//CALCULATE RESULTS
//global $InterimWeight;
    var $Week = 1;
    var $InterimWeight = (+$CurrentWeight);
    const $ResultsWeek = ["Week"];
    const $ResultsWeight = ["Your Est. Weight"];
    const $ResultsTDEE = ["TDEE Cals"];
    const $ResultsProgramCal = ["Program Cals"];
    const $ResultsWeightChange = ["Est. Weight Change"];
    $ResultsWeightChange[$Week] = 0;  //on the first week the weight change is 0
    var $WeeklyWeightChange;
    var $OrgProgramCal = $ProgramCal;

do {
    //Populate array
    $ResultsWeek[$Week] = $Week;
    $ResultsWeight[$Week] = $InterimWeight.toFixed(1);
    $ResultsTDEE[$Week] = $TDEE.toFixed(0);
    $ResultsProgramCal[$Week] = $ProgramCal;

    $Week = $Week + 1;
    
    if ($Gender == "Male") {
        $BMR = (10*$InterimWeight)+(6.25*$Height)-(5*$Age)+5;
    }
    else if ($Gender == "Female") {
        $BMR = (10*$InterimWeight)+(6.25*$Height)-(5*$Age)+161;
    }
    
    $TDEE = ($BMR*$ActivityLevel);
    
    $WeeklyWeightChange = (($ProgramCal - $TDEE)*0.00012959782*7);
    
    $InterimWeight = $InterimWeight + $WeeklyWeightChange;
    
    $ResultsWeightChange[$Week] = $WeeklyWeightChange.toFixed(1);
        
    //Make adjustments to the Program Calories if the weight loss is slowing
    //taking into account if person is losing or gaining weight
    if ($CurrentWeight > $TargetWeight) {
        if (($TDEE - $ProgramCal) < 500) {
        $ProgramCal = $ProgramCal - 250;
    }
    }
    else if ($CurrentWeight < $TargetWeight) {
        if (($ProgramCal - $TDEE) < 500) {
            $ProgramCal = $ProgramCal + 250;
    }
    }
    
    if ($Week > 180) {
        break;
    }    

    } while (Math.abs($InterimWeight - $TargetWeight) > 1.0);

    //Populate array with last values
    $ResultsWeek[$Week] = $Week;
    $ResultsWeight[$Week] = $InterimWeight.toFixed(1);
    $ResultsTDEE[$Week] = $TDEE.toFixed(0);
    $ResultsProgramCal[$Week] = $ProgramCal;


    //Print results into HTML
    document.getElementById("resultsHeight").innerHTML = "Your Height:" + $Height + " cm";
    document.getElementById("resultsAge").innerHTML = "Your Age:" + $Age + " years";
    document.getElementById("resultsCurrentWeight").innerHTML = "Your Current Weight:" + $CurrentWeight + " kg";
    document.getElementById("resultsTargetWeight").innerHTML = "Your Target Weight:" + $TargetWeight + " kg";
    document.getElementById("resultsCurrentBMI").innerHTML = "Your Current BMI: " + $CurrentBMI.toFixed(1); 
    document.getElementById("resultsTargetBMI").innerHTML = "Your Target BMI: " + $TargetBMI.toFixed(1);
    document.getElementById("resultsWeightChange").innerHTML = "Your Overall Weight Change: " + $WeightChange.toFixed(1) + " kg";
    document.getElementById("resultsWeeks").innerHTML = $Week + " Weeks";
    document.getElementById("resultsProgram").innerHTML = $OrgProgramCal + " Program";

if ($TargetBMI < 19.5) {
    noProgam();
}  
else if ($TargetBMI >= 30 && $TargetBMI > $CurrentBMI) {
    noProgam();
}

else if ($TargetBMI >= 19.5) {
//Show correct Meal plan
if ($OrgProgramCal == "0" || $OrgProgramCal == "1200" || $OrgProgramCal == "3000" || $OrgProgramCal == "3500" || $OrgProgramCal == "4000") {
    noProgam();
}

else if ($OrgProgramCal == "1500") {
    document.getElementById("AussielentMealPlan").innerHTML = "<h2>Your Recommended Meal Plan</h2>" + "<p><img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/AussielentKickstart1500.png?v=1635915397\" width=\"800\">";
    document.getElementById("product1").innerHTML = "<p></p>";
    document.getElementById("plus").innerHTML = "<h1></h1>";
    document.getElementById("product2").innerHTML = "<img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/WL_Low-Carb_Vanilla.png?v=1634184237\" width=\"200\"\">" + "<p>Low-Carb Powder</p>";
    document.getElementById("bundlebutton").setAttribute('onclick',"window.location.href='https://aussielent.com.au/products/3-week-kickstart'");
}
else if (($OrgProgramCal == "1750") || ($OrgProgramCal == "2000") || ($OrgProgramCal == "2500")) {
    document.getElementById("AussielentMealPlan").innerHTML = "<h2>Your Recommended Meal Plan</h2>" +
"<p><img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/Aussielent" + $OrgProgramCal + ".png\" width=\"800\">";
    document.getElementById("product1").innerHTML = "<img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/WL_Powder_Choc.png?v=1634184237\" width=\"200\"\">" + "<p>Regular Powder</p>";
    document.getElementById("plus").innerHTML = "<h1>+</h1>";
    document.getElementById("product2").innerHTML = "<img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/WL_Vanilla_RTD.png?v=1634184237\" width=\"200\"\">" + "<p>Ready To Drink</p>";
    document.getElementById("bundlebutton").setAttribute('onclick',"window.location.href='https://aussielent.com.au/products/nutrition'");
}
}


//Show results
    document.getElementById("resultsTabledisplay").style.display = 'block';
    document.getElementById("productsTabledisplay").style.display = 'block';
    document.getElementById("AussielentMealPlan").style.display = 'block';
    document.getElementById("userFormdisplay").style.display = 'none';
    }

    function rerunCalc() {
        document.getElementById("resultsTabledisplay").style.display = 'none';
        document.getElementById("productsTabledisplay").style.display = 'none';
        document.getElementById("AussielentMealPlan").style.display = 'none';
        document.getElementById("userFormdisplay").style.display = 'flex';
    }

    function noProgam() {
        document.getElementById("AussielentMealPlan").innerHTML = "<h2>Your Recommended Meal Plan</h2>" +
        "<p>Sorry we can't calculate a program for you today.<br>  Please discuss your specific weight goals with your doctor or nutritionist.</p>" +
        "<p><img src=\"\">";
        document.getElementById("resultsWeeks").innerHTML = "-"; 
        document.getElementById("resultsProgram").innerHTML = "-";
        document.getElementById("product1").innerHTML = "<img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/WL_Powder_Choc.png?v=1634184237\" width=\"200\"\">" + "<p>Regular Powder</p>";
        document.getElementById("plus").innerHTML = "";
        document.getElementById("product2").innerHTML = "<img src=\"https://cdn.shopify.com/s/files/1/1959/3109/files/WL_Vanilla_RTD.png?v=1634184237\" width=\"200\"\">" + "<p>Ready To Drink</p>";
        document.getElementById("bundlebutton").setAttribute('onclick',"window.location.href='https://aussielent.com.au/collections/all'");
        }